import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get, del, post } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "./MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "./TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import AddPartner from "./AddPartner";
import ViewUpStream from "./ViewPartner";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../../Layout/MainSidebar";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { every } from "lodash";

const UpStream = () => {
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Industry: false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    Industry: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    industry: [],
  });

  const filters = ["Date", "Industry"];
  const [searchQuery, setSearchQuery] = useState("");
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    industry: [],
  });
  const inputData = [
    {
      fieldName: "partner",
    },
    {
      fieldName: "industry",
      title: " Industry",
      placeholder: "Tap to Select",
      type: "select",
    },
    {
      fieldName: "address",
      title: "Address",
      placeholder: "Enter Address",
    },
    {
      fieldName: "country",
      title: "Country",
      placeholder: "Tap to Select",
      type: "select",
    },
    {
      fieldName: "contactPersonName",
      title: "Contact Person Name",
      placeholder: "Enter Contact Person Name",
    },
    {
      fieldName: "contactNumber",
      title: "Contact Number",
      placeholder: "Enter Mobile No ",
    },
    {
      fieldName: "email",
      title: "Email ID",
      placeholder: "Enter Email",
    },
    {
      fieldName: "materialsOrServices",
      title: "Materials / Services involved in business ",
      placeholder: "Materials / Services",
    },
  ];
  console.log("temp11", tempFilter);
  const fetchUniqueValues = async () => {
    try {
      const queryParams = new URLSearchParams({
        direction: "Upstream",
        page: 1,
        limit: 100,
      }).toString();
      const response = await get(
        `/valueChain/partner/valuechainFilters?${queryParams}`
      );
      const data = response?.data?.data?.data;
      const uniqueIndustries = [
        ...new Set(data.map((el) => el).filter(Boolean)),
      ];
      return {
        industry: uniqueIndustries,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
        direction: "Upstream",
        search: searchQuery,
      }).toString();
      const response = await get(`/valueChain/partner/get?${queryParams}`);
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig, searchQuery]);

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  const handleMenuClick = (event, element) => {
    console.log("item1", event, element);
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };
  const handleRequestData = async (id) => {
    try {
      handleMenuClose();
      const response = await post(`${api}/valueChain/request/requestData`, {
        _id: id,
      });

      setsnackOpen({
        open: true,
        message: response?.data?.message,
        severity: "success",
      });
      fetchData();
    } catch (error) {
      setsnackOpen({
        open: true,
        message: error?.response?.data?.message,
        severity: "error",
      });
    }
  };

  const handleDeleteAggree = async () => {
    try {
      const res = await del(`/valueChain/partner/get/${element._id}`);
      setDeleteDialog(false);
      setsnackOpen({
        open: true,
        message: res.data.message,
        severity: "success",
      });
      fetchData();
    } catch (err) {
      console.log(err);
      setsnackOpen({
        open: true,
        message: err.data?.response.message ?? "network Error",
        severity: "error",
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    industry: tempFilter?.industry?.length
      ? tempFilter?.industry.join(",")
      : "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      industry: false,
    };

    if (selectedFilter === "Date") {
      const today = new Date();
      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      // Ensure that the startDate is less than or equal to the endDate
      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    if (!validateFilters()) return;
    setPage(1);
    fetchData(filtersToApply);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      industry: tempFilter?.industry,
    });
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setTempFilter({
      startDate: null,
      endDate: null,
      industry: [],
    });
    setStartDate(null);
    setEndDate(null);
    setSelectedFields({
      industry: [],
    });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isIndustryApplied = tempFilter.industry?.length > 0 ? true : false;

    setIsFiltersApplied(isDateApplied || isIndustryApplied);

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      Industry: isIndustryApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      industry: selectedFields?.industry,
    });
    setDrawerFilterOpen(false);
    // setErrors({ Date: false, Country: false });
  };

  const columnHeadings = [
    {
      fieldName: "createdAt",
      title: "Date",
    },
    {
      fieldName: "partnerCompany",
      title: "Value Chain Partner",
    },
    {
      fieldName: "industry",
      title: "Industry",
    },
    {
      fieldName: "contactPersonName",
      title: "Contact Person",
    },
    {
      fieldName: "contactNumber",
      title: "Mobile",
    },
  ];

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Industry":
        return (
          <MultiSelect
            title="Industry"
            url={`${api}/valueChain/partner/get`}
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  industry: newValue.industry || newValue,
                };
              });
            }}
            errors={errors.Industry}
            setErrors={setErrors}
            field="industry"
            data={uniqueValues.industry}
          />
        );

      default:
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
    }
  };

  // const handleClose = () => {
  //   setElement({});
  // };

  return (
    <MainDashboardLayout sidebar={<MainSidebar />}>
      <Unauthorized requiredModule="Value Chain | Partner">
        <Box
          sx={{
            // padding: "20px",
            backgroundColor: "#ededed",
            width: "100%",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />

          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <AddPartner
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={data}
            element={element}
            addUrl={`${api}/valueChain/partner/add`}
            updateUrl={`${api}/valueChain/partner/update`}
            // details={vehicle}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
            direction="Upstream"
          />

          <ViewUpStream
            id={element ? element._id : ""}
            data={element}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          <TopMenu
            setData={setElement}
            setAddData={setAddData}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            {...{
              heading: "Value Chain",
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          {deleteDialog && (
            <DeleteDialog
              {...{
                deleteDialog,
                setDeleteDialog,
                handleDeleteAggree,
                setsnackOpen,
                id: element?._id,
                url: `/valueChain/partner/delete`,
                fetchData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}

          <TableContainer
            component={Paper}
            sx={{ maxWidth: "100%" }}
            ref={tableContainerRef}
          >
            <Box>
              <TableHeading heading={"Value Chain Partners"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "12% 17% 17% 20% 25% 8%",
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => (
                  <ColumnHeadings
                    key={el.fieldName}
                    {...{
                      title: el.title,
                      handleSort,
                      field: el.fieldName,
                      sortConfig,
                    }}
                  />
                ))}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "12% 17% 17% 20% 25% 8%",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) => {
                      const fieldData = item[el.fieldName];
                      let displayValue;
                      if (el.fieldName === "partnerCompany") {
                        displayValue =
                          fieldData?.companyName || item.newPartnerName;
                      } else if (
                        el.fieldName === "contactNumber" &&
                        fieldData
                      ) {
                        const countryCode = fieldData.countryCode?.startsWith(
                          "+"
                        )
                          ? fieldData.countryCode
                          : `+${fieldData.countryCode}`;
                        displayValue = `${countryCode} ${fieldData.mobileNo}`;
                      } else if (
                        typeof fieldData === "object" &&
                        fieldData !== null
                      ) {
                        displayValue = JSON.stringify(fieldData);
                      } else {
                        displayValue = fieldData;
                      }

                      return (
                        <TableContent
                          key={el.fieldName}
                          {...{
                            fieldData: displayValue,
                            dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                          }}
                        />
                      );
                    })}
                    {console.log("itemmmmmmm", item)}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
              partnerType: selectedData?.partner,
              sendForApproval: selectedData?.sendForApproval,
              handleRequestData: () => handleRequestData(element?._id),
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default UpStream;
